import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'retailers-opt_in_nudge_dismiss-dismiss';

/**
 * Track user dismiss of the popup prompt nudge, for opt-in nudges.
 */
export function trackRetailersOptInNudgeDismissDismiss(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
